import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import transactionService  from "./transactionService";
import {TransactionI} from "../../interfaces";

interface TransactionStateI {
    isLoading: boolean;
    isSuccessful: boolean;
    transactions: TransactionI;
}

const initialState: TransactionStateI = {
    isLoading: false,
    isSuccessful: false,
    transactions: {
        employerContribution: 0,
        employeeContribution: 0,
        voluntaryContribution: 0,
        withdrawal: 0,
        withdrawalFromVoluntary: 0,
        contributionDate: "",
        valueDate: "",
        fee: 0,
        narration: "",
        description: "",
        totalContribution: ""
    },
};

export const getTransactionHistory = createAsyncThunk(
    "transaction/getTransactionHistory",
    async (_,{rejectWithValue}) => {
        try {
            const response = await transactionService.getTransactionHistory();
            if (response.status !== 200) {
                toast.error(response?.data?.statusMessage);
                return;
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ message: string }>;
            toast.error(err.response?.data.message);
            return err?.response?.data;
        }
    }
);

export const transactionSlice = createSlice({
    name: "transactions",
    initialState,
    reducers: {
        noTract: () => {},
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTransactionHistory.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                };
            })
            .addCase(getTransactionHistory.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    transactions: action.payload as TransactionI
                };
            })
            .addCase(getTransactionHistory.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                    //error: action.payload.message,
                };
            });
    },
});

export default transactionSlice.reducer;
